//All pages
(function ($) {
  var windowObj = $(window); //window cached in var for performance
  var officewsBody = $('body'); //body cached in var for performance
  var documentObj = $(document);
  /***
  ********
  ****
  Smooth Scrolling Function (redunant due to hashHandler()?)
  ****
  ********
  ***/
  function smoothScrolling() {
    $('a[href*=\\#]:not([href=\\#],[href="\\#0"],[data-toggle="tab"],.no-smooth-scroll)').click(function() {
      if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) +']');

        let offset = (window.innerWidth < 992 ? 30 : 50);
        offset += document.querySelector('.site-header__navbar').offsetHeight;
        offset += (document.body.classList.contains('admin-bar') ? document.getElementById('wpadminbar').offsetHeight : 0);

        if (target.length) {
          $('html,body').animate({
            scrollTop: target.offset().top - offset
          }, 1000);
          return false;
        }
      }
    });
  }
  smoothScrolling();
  /***
  ********
  ****
  Return to top anchor
  ****
  ********
  ***/
  function returnTop() {
    var returnTop = $('.return-to-top');
    windowObj.scroll(function() {
      if ($(this).scrollTop() >= 50) {
        returnTop.fadeIn(200);
      } else {
        returnTop.fadeOut(200);
      }
    });
    returnTop.on('click', function(){
      $('body,html').animate({
        scrollTop : 0
      }, 500);
    });
  }
  /******* Executed in document ready at end of file *******/
  /***
  ********
  ****
  officews Navbar Functionality
  ****
  ********
  ***/
  function officewsNavbar() {
    var site_header = $('.site-header');
    var nav_toggle = $('.site-header__navbar-toggler');
    //shrink navbar on scroll
    windowObj.scroll(function() {
      if (documentObj.scrollTop() > 50) {
        if (site_header.hasClass('site-header--transparent')) {
          site_header.removeClass('site-header--transparent');
          site_header.addClass('site-header--shrink site-header--return-to-transparent');
        }
        else if (site_header.hasClass('site-header--white-bg')) {
          site_header.addClass('site-header--shrink');
        }
      }
      else {
        if (site_header.hasClass('site-header--return-to-transparent')) {
          site_header.removeClass('site-header--return-to-transparent site-header--shrink');
          site_header.addClass('site-header--transparent');
        }
      }
    });
    var slide_out_navbar = $('.slideout-navbar');
    var sub_menu = $('.sub-menu');
    $('.navbar-dropdown-anchor-parent').on('click',function(e){
      e.preventDefault();
      slide_out_navbar.addClass('slideout-navbar--visible');
      sub_menu.removeClass('sub-menu-visible');
      $(this).next('.sub-menu').addClass('sub-menu-visible');
    });
    $('.slideout-navbar__close').on('click',function(){
      sub_menu.removeClass('sub-menu-visible');
      slide_out_navbar.removeClass('slideout-navbar--visible');
    });
    $('.close-sub-menu-btn').on('click',function(){
      sub_menu.removeClass('sub-menu-visible');
      slide_out_navbar.removeClass('slideout-navbar--visible');
    });
  }
  /******* Executed in document ready at end of file *******/
  /***
  ********
  ****
  GDPR Consent Bar Functionality
  ****
  ********
  ***/
  function gdprConsent() {
    var gdprConsentBar = $('.gdpr-consent');
    windowObj.scroll(function() {
      if (documentObj.scrollTop() > 70) {
        gdprConsentBar.addClass('gdpr-hidden animated');
      }
      else {
        gdprConsentBar.removeClass('gdpr-hidden animated');
      }
    });

    $('.gdpr-give-consent').click(function(event){
      event.preventDefault();
      Cookies.remove('officews_gdpr_consent_undecided');
      Cookies.set('officews_gdpr_consent', 1, { expires: 365, path: '/' });
      gdprConsentBar.hide();
      //$('.gdpr-consent__accepted-notice').addClass('show-accepted-message animated');
    });

    $('.gdpr-close').click(function(event){
      gdprConsentBar.addClass('gdpr-hidden animated');
      setTimeout(function() { gdprConsentBar.remove(); }, 2000);
    });
  }
  /******* Executed in document ready at end of file *******/
  /***
  ********
  ****
  officews Accordion Functionality
  ****
  ********
  ***/
  function officewsAccordions() {
    $('.accordion__title').each(function() {
      var accordion = $(this), state = false, accordionContent = accordion.next('.accordion__content').hide().css('height','auto').slideUp();
      accordion.click(function() {
        state = !state;
        accordionContent.slideToggle(state);
        accordion.parent().toggleClass('accordion-open',state);
      });
    });
  }
  officewsAccordions();
  /******* Executed in document ready at end of file *******/
  /***
  ********
  ****
  officews horizontal tabs flickity init
  ****
  ********
  ***/
  function horizontalTabsInit() {
    $('.officews-horizontal-tabs__content').each(function() {

      // init Flickity
      var $carousel = $(this).flickity({
        prevNextButtons: false,
        pageDots: false,
        autoPlay: $(this).data('autoplay')
      });
      // Flickity instance
      var flkty = $carousel.data('flickity');
      // elements
      var $cellButtonGroup = $('.officews-horizontal-tabs__nav');
      var $cellButtons = $cellButtonGroup.find('.officews-horizontal-tabs__nav__item');

      // update selected cellButtons
      $carousel.on( 'select.flickity', function() {
        $cellButtons.filter('.is-selected')
          .removeClass('is-selected');
        $cellButtons.eq( flkty.selectedIndex )
          .addClass('is-selected');
      });

      // select cell on button click
      $cellButtonGroup.on( 'click', '.officews-horizontal-tabs__nav__item', function() {
        var index = $(this).index();
        $carousel.flickity( 'select', index );
      });

    });
  }
  /******* Executed in document ready at end of file *******/
  /***
  ********
  ****
  officews testimonial carousel
  ****
  ********
  ***/
  function testimonialCarouselInit() {
    $('.officews-testimonial-carousel__content__testimonials').each(function() {

      // init Flickity
      var $carousel = $(this).flickity({
        prevNextButtons: false,
        wrapAround: true,
        autoPlay: $(this).data('autoplay')
      });

    });
  }
  /******* Executed in document ready at end of file *******/
  /***
  ********
  ****
  officews carousel
  ****
  ********
  ***/
  function carouselInit() {
    $('.officews-carousel__items').each(function() {

        // init Flickity
        var $carousel = $(this).flickity({
          pageDots: false,
          contain: true,
          resize: true,
          autoPlay: $(this).data('autoplay')
        });

    });
  }
  /******* Executed in document ready at end of file *******/
  /***
  ********
  ****
  officews resources carousel
  ****
  ********
  ***/
  function resourcesCarouselInit() {
    $('.resources-carousel__carousel').each(function() {

      // init Flickity
      var $carousel = $(this).flickity({
        pageDots: false,
        wrapAround: 'fill',
        resize: true,
        autoPlay: $(this).data('autoplay'),
        //percentPosition: false
      });

    });
  }
  /******* Executed in document ready at end of file *******/
  /***
  ********
  ****
  Animated Sections
  ****
  ********
  ***/
  function animateSections() {
    /*$('.watch-in-view').each(function() {
      var vBlock = new Waypoint.Inview({
        element: this,
        enter: function(direction) {
          $(this.element).addClass('in-view');
        },
        offset: -50
      });
    });*/
    $('.watch-in-view').each(function() {
      var vBlock = new Waypoint.Inview({
        element: this,
        enter: function(direction) {
          $(this.element).addClass('in-view animate__animated');
          //console.log('Enter triggered with direction ' + direction + ' ' + this.element);
        },
        offset: {
          //top: 200, // 300px
          bottom: 200 // 200px
        }
      });
    });
  }
  /******* Executed in document ready at end of file *******/
  /***
  ********
  ****
  Animated Sections
  ****
  ********
  ***/
  function animatedStatistics() {
    $('.statistic-columns__item__statistic__value,.statistic-bar__item__statistic__value').each(function () {
      var $this = $(this);
      var vBlock = new Waypoint.Inview({
        element: this,
        enter: function(direction) {
          var start = $(this.element).data('start');
          var target = $(this.element).data('target');
          $({ Counter: start }).animate({ Counter: target }, {
            duration: 1000,
            easing: 'swing',
            step: function (now) {
              $this.text(Math.ceil(now));
            }
          });
          this.destroy();
        },
        offset: {
          //top: 200, // 300px
          bottom: 200 // 200px
        }
      });
    });
  }
  /******* Executed in document ready at end of file *******/
  /***
  ********
  ****
  Flickity Carousel
  ****
  ********
  ***/
  function clientCarousel() {
    var carousel = $('.client-carousel__carousel');
    if (carousel != null) {
      var $carousel = $('.client-carousel__carousel').flickity({
        // options
        cellAlign: 'center',
        pageDots: false,
        wrapAround: true,
        adaptiveHeight: true,
        prevNextButtons: false,
        autoPlay: 3000
      });
    }
  }
  /******* Executed in document ready at end of file *******/
  /***
  ********
  ****
  Flickity Carousel
  ****
  ********
  ***/
  function heroCarousel() {
    var carousel = $('.thumbnail-nav__carousel');
    if (carousel != null) {
      var $carousel = $('.thumbnail-nav__carousel').flickity({
        // options
        cellAlign: 'center',
        pageDots: false,
        wrapAround: true,
        adaptiveHeight: true,
        watchCSS: true
      });
    }
  }
  /******* Executed in document ready at end of file *******/
  /***
  ********
  ****
  Flickity Carousel
  ****
  ********
  ***/
  function portfolioCarousel() {
    var carousel = $('.portfolio__carousel');
    if (carousel != null) {
      if (windowObj.width() > 1200) {
        var cellSelector = '.portfolio__group';
      }
      else {
        var cellSelector = '.portfolio__item';
      }
      var $carousel = $('.portfolio__carousel').flickity({
        // options
        cellAlign: 'center',
        pageDots: false,
        wrapAround: true,
        resize: true,
        cellSelector: cellSelector
      });
    }
  }
  /******* Executed in document ready at end of file *******/
  /***
  ********
  ****
  Bootstrap Tabs
  ****
  ********
  ***/
  function bsTabs() {
    if (windowObj.width() < 1200) {
      $('.nav-link').on('show.bs.tab', function (e) {
        var tab_anchor = $(this).closest('.tabs__title-and-nav').next('.tabs__tabbed-content').children('.tab-content-anchor');
        $('html, body').animate({
          scrollTop: tab_anchor.offset().top
        }, 500);
      });
    }

    $('.tabs__prev-next__next').on('click',function() {
      //var nextTabLinkEl = $('.nav-tabs .active').closest('li').next('li').find('button')[0];
      var nextTabLinkEl = $(this).closest('.tabs').find('.tabs__tabs').find('.active').closest('li').next('li').find('button')[0];
      var nextTab = new bootstrap.Tab(nextTabLinkEl);
      nextTab.show();
    });

    $('.tabs__prev-next__previous').on('click',function() {
      //var prevTabLinkEl = $('.nav-tabs .active').closest('li').prev('li').find('button')[0];
      var prevTabLinkEl = $(this).closest('.tabs').find('.tabs__tabs').find('.active').closest('li').prev('li').find('button')[0];
      var prevTab = new bootstrap.Tab(prevTabLinkEl);
      prevTab.show();
    });
  }
  /******* Executed in document ready at end of file *******/
  /***
  ********
  ****
  Bootstrap Tabs
  ****
  ********
  ***/
  function isotopeGallery() {
    var $grid = $('.gallery__gallery').isotope({
      // main isotope options
      itemSelector: '.gallery__item',
      // set layoutMode
      layoutMode: 'packery',
      // options for masonry layout mode
      packery: {
        gutter: '.gallery__gutter-sizer'
      }
    });
    //wait till images have loaded so they have correct size, then render layout
    $grid.imagesLoaded().progress( function() {
      $grid.isotope('layout');
    });
  }
  /******* Executed in document ready at end of file *******/
  //mediabox video modals
  MediaBox('.mediabox');
  //match height of grouped elements
  $('.matchHeight').matchHeight();

  /***
  ********
  ****
  Functions which require document to be ready
  ****
  ********
  ***/
  $(function() {
    officewsNavbar();
    returnTop();
    gdprConsent();
    animateSections();
    animatedStatistics();
    clientCarousel();
    bsTabs();
    isotopeGallery();
    horizontalTabsInit();
    testimonialCarouselInit();
    carouselInit();
    resourcesCarouselInit();
    heroCarousel();
    portfolioCarousel();
    windowObj.on('resize',portfolioCarousel);
  });
})(jQuery); // Fully reference jQuery after this point.
